import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data?.company) {
            datas.company = data?.company
        }
        if (data?.customer) {
            datas.customer = data?.customer
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data.id) {
            datas.id = data.id
        }
    }
    return ApiService.get('/api/v1/xero/configurations/', datas)
}

export const createApiRecord = data => ApiService.post('/api/v1/xero/configurations/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/xero/configurations/${id}/`)
export const updateApiRecord = (id, data) => ApiService.patch(`/api/v1/xero/configurations/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/xero/configurations/${id}/`)
export const testConnection = id => ApiService.post(`/api/v1/xero/configurations/${id}/test_connection/`)
export const authorize = (id, data) => ApiService.post(`/api/v1/xero/configurations/${id}/authorize/`, data)
export const clearTokens = id => ApiService.post(`/api/v1/xero/configurations/${id}/clear_tokens/`)

// New one-click authorization that doesn't require client credentials
export const oneClickAuthorize = (companyId, customerId) => {
    const data = { company_id: companyId }
    if (customerId) {
        data.customer_id = customerId
    }
    return ApiService.post('/api/v1/xero/oauth/one-click-authorize/', data)
}

// Trigger full sync of all Xero data for a company
export const syncAllXeroData = companyId => {
    // If companyId is provided, include it in the request
    const data = companyId ? { company_id: companyId } : {}
    return ApiService.post('/api/v1/xero/sync/all/', data)
}

// Trigger incremental sync of Xero data for a company (last 2 days)
export const syncIncrementalXeroData = companyId => {
    // If companyId is provided, include it in the request
    const data = companyId ? { company_id: companyId } : {}
    return ApiService.post('/api/v1/xero/sync/incremental/', data)
}
